module.exports = __webpack_public_path__ + "static/img/icon4.4db3ab5b.svg";